module.exports = __webpack_public_path__ + "static/media/lavabos.cd689786.svg";